import { screenSize } from "@src/theme";
import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const Container = styled.div`
  width: 100%;
  max-width: ${screenSize.desktopXL};
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin: 0 auto;
  box-sizing: border-box;
`;
const ContentDiv = styled.div<{ $allowScroll?: boolean }>`
  width: 100%;
  max-width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: ${({ $allowScroll }) => ($allowScroll ? "auto" : "hidden")};
  overflow-x: hidden;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
`;

type ContentContainerProps = {
  children?: React.ReactNode;
  contentContainerStyles?: React.CSSProperties;
  allowScroll?: boolean;
};

const ContentContainer = ({
  children,
  contentContainerStyles,
  allowScroll = false,
}: ContentContainerProps): React.JSX.Element => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.3 } }}
      exit={{ opacity: 0, transition: { duration: 0.3 } }}
      transition={{ type: "tween", ease: "easeInOut", duration: 0.3 }}
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      <Container>
        <ContentDiv $allowScroll={allowScroll} style={contentContainerStyles}>
          {children}
        </ContentDiv>
      </Container>
    </motion.div>
  );
};

export default ContentContainer;
